import {
  getItemOrDefaultToValue,
  getPersonName,
  getElapsedTime,
} from '../../details';
import { getStatusValue } from '../../helper/patrol';
import { displayTime } from '../../time';

export const transform = (list, currentTime, timeZone) => {
  return list.map(data => ({
    id: data.id,
    businessClientName:
      data.patrolDefinition != null
        ? getItemOrDefaultToValue(
            data.patrolDefinition.businessClient,
            'businessClientName',
            '-',
          )
        : '-',
    siteName:
      data.patrolDefinition != null
        ? getItemOrDefaultToValue(data.patrolDefinition.site, 'siteName', '-')
        : '-',
    patrolDefinitionName:
      data.patrolDefinition != null
        ? getItemOrDefaultToValue(data.patrolDefinition, 'definitionName', '-')
        : '-',
    patrolId: getItemOrDefaultToValue(data, 'patrolId', '-'),
    timeStarted: displayTime({
      timestamp: getItemOrDefaultToValue(data, 'startTime'),
      timeZone,
    }),
    patrollerName: getPersonName(data.patroller.general),
    elapsedTime: getElapsedTime(data, currentTime),
    status: data.currentStatus != null ? getStatusValue(data) : '-',
  }));
};
